import { render, staticRenderFns } from "./SpinnerChart.vue?vue&type=template&id=1a2dee20&scoped=true"
import script from "./SpinnerChart.vue?vue&type=script&lang=js"
export * from "./SpinnerChart.vue?vue&type=script&lang=js"
import style0 from "./SpinnerChart.vue?vue&type=style&index=0&id=1a2dee20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2dee20",
  null
  
)

export default component.exports